import { BaseService } from "mrb/core";
import { ProducerReportApiRouteService } from "common/services";

class ProducerReportService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new ProducerReportApiRouteService());
    }

    findProducerReportPayoutUserEvents(filter, abortSignal = null) {
        const url = this.routeService.findProducerReportPayoutUserEvents(filter);
        return this.apiClient.get(url, null, abortSignal);
    }

    findProducerReports(filter, abortSignal = null) {
        const url = this.routeService.findProducerReports(filter);
        return this.apiClient.get(url, null, abortSignal);
    }

    getProducerPaymentSummary(producerId, options, abortSignal = null) {
        const url = this.routeService.getProducerPaymentSummary(producerId, options);
        return this.apiClient.get(url, null, abortSignal);
    }

    findProducerReportItems(filter, abortSignal = null) {
        const url = this.routeService.findProducerReportItems(filter);
        return this.apiClient.get(url, null, abortSignal);
    }

    findProducerReportTrackItems(filter, abortSignal = null) {
        const url = this.routeService.findProducerReportTrackItems(filter);
        return this.apiClient.get(url, null, abortSignal);
    }

    findProducerReportContentItems(filter, abortSignal = null) {
        const url = this.routeService.findProducerReportContentItems(filter);
        return this.apiClient.get(url, null, abortSignal);
    }

    findProducerReportTrackListeners(filter, abortSignal = null) {
        const url = this.routeService.findProducerReportTrackListeners(filter);
        return this.apiClient.get(url, null, abortSignal);
    }

    findRevenueMap(filter, abortSignal = null) {
        const url = this.routeService.findRevenueMap(filter);
        return this.apiClient.get(url, null, abortSignal);
    }

    getProducerReportTrackItemsCsv(filter, producerId, abortSignal = null) {
        const url = this.routeService.getProducerReportTrackItemsCsv(filter, producerId);
        return this.apiClient.get(url, { responseType: "blob" }, abortSignal);
    }
}

export default ProducerReportService;
